// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"15ad3bb5","787":"d06df960"}[chunkId] + ".chunk.js";
};